import {
  ChangeDetectionStrategy,
  Component,
  computed,
  inject,
  Injector,
  input,
  runInInjectionContext,
  signal,
  WritableSignal,
} from '@angular/core';
import { rxResource, toSignal } from '@angular/core/rxjs-interop';
import { allAreas, AppState, ConfigService, ResourceService } from '@assist/shared/data';
import { AssistResourceBM } from '@cue/api';
import { cueArrowRight, cueCheck, cueClose, cueQrCode, IconComponent } from '@cue/ui/icons';
import { Store } from '@ngrx/store';
import { WorkingHoursComponent } from '@cue/ui';
import { FileGalleryComponent } from '@cue/ui/file-gallery';
import { CustomUnsafeSanitizePipe } from '@cue/security';
import { ImageWidthPipe, LocalizedStringPipe } from '@cue/utilities';
import { translation } from '@cue/translations';
import { TranslocoPipe, TranslocoService } from '@jsverse/transloco';
import { PoiComponent } from '@cue/poi';

import { NavigationDetailInfo, NavigationService } from '@cue/navigation-services';

import { RouterLink } from '@angular/router';

@Component({
  selector: 'assist-multiview-detail',
  imports: [
    IconComponent,
    WorkingHoursComponent,
    FileGalleryComponent,
    CustomUnsafeSanitizePipe,
    LocalizedStringPipe,
    TranslocoPipe,
    ImageWidthPipe,
    PoiComponent,
    RouterLink,
  ],
  templateUrl: './multiview-detail.component.html',
  styleUrl: './multiview-detail.component.scss',
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class MultiviewDetailComponent {
  ICONS = {
    cueArrowRight,
    cueCheck,
    cueClose,
    cueQrCode,
  };
  #store = inject(Store<AppState>);
  navigationService = inject(NavigationService);
  configService = inject(ConfigService);
  translocoService = inject(TranslocoService);
  translation = translation;
  areas = toSignal(this.#store.select(allAreas()));
  qrCodeId = input.required<string>();
  resource = input.required<AssistResourceBM | null>();
  serverDetail = input<NavigationDetailInfo | null>(null);
  loading = input<boolean>();
  resourceService = inject(ResourceService);
  breadcrumb = computed(() => {
    if (!this.resource()) {
      return [];
    }
    return this.resourceService.getBreadcrumbForResourceInstant(this.resource(), this.areas().data);
  });
}
